module.exports = __webpack_public_path__ + "static/media/sv.65b5b93a.svg";